import { render, staticRenderFns } from "./cg-card-collection.vue?vue&type=template&id=51600258&scoped=true&"
import script from "./cg-card-collection.vue?vue&type=script&lang=js&"
export * from "./cg-card-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51600258",
  null
  
)

export default component.exports